import { io } from "socket.io-client";

const API_URL = process.env.REACT_APP_API_URL;

console.log("REACT_APP_API_URL =", API_URL);

if (!API_URL) {
  throw new Error("Missing REACT_APP_API_URL");
}

export const socket = io(API_URL, {
  autoConnect: false,
  transports: ["websocket", "polling"],
});